// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mcqMainDiv{
  margin: 80px 24px 10px 24px;

}
.nextQuestionDiv{
    display: flex;
    justify-content: space-between;
}
.questionCard label{
    display: flex;
    margin-bottom: 15px;
}
.questionParagraph{
    margin-bottom: 32px !important;
}
.questionChartItems {
    border: 1px solid #000000;
    padding: 7px;
    background: #ffffff;
    color: #070707;
    border-radius: 100%;
    width: 23px;
    height: 20px;
    /* cursor: pointer; */
    display: flex;
    justify-content: center;

}
.questionChartItems p {
  display: contents;
}
.questionChartItemsSelected p {
  display: contents;
}
.questionChartItemsDiv{
    display: flex;
    justify-content: space-around;
    margin-bottom: 13px;
}
.mcqMainDiv .ant-card-bordered{
    border: 1px solid #b5b5b5;
}
.mcqMainDiv .ant-card-head{
    border-bottom: 1px solid #b5b5b5;
}

.questionChartItemsSelected {
    background-color: #1677ff; /* Green for correct answers */
    border: 1px solid #1677ff;
    padding: 7px;
    color: #ffffff;
    border-radius: 100%;
    width: 23px;
    height: 20px;
    cursor: pointer;
    display: flex;
    justify-content: center;  
}
  
  .questionChartItems.incorrect {
    background-color: #ff6666; /* Red for incorrect answers */
  }
  .Thanks{
    font-size: 60px;
    font-weight: 400;
    margin-top: 70px;
    margin-bottom: 0px;
  }
  .mcq-res-MainDiv{
    display:flex ;
    justify-content: center;
  }
  .QuestionHeader{
    display: flex;
    justify-content: space-between;
  }
  .Ques-txt{
    color: #0174fa;
    padding-top: 16px;
  }
  /* .questionChartItems:hover{
    background: #b6d8fff4;
  } */
  .mcq-res-MainDiv{
    display: flex;
  }
  .BackToDashboard{
    margin-left: 96px;
  }
  .completed{
    text-align: center;
  }
  .back{
    color: #4096FF;
    cursor: pointer; 
    font-size: 12px;
    /* text-decoration: underline; */
}`, "",{"version":3,"sources":["webpack://./src/Components/Training/TrainingAssessment/MCQ/Mcq.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;;AAE7B;AACA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,uBAAuB;;AAE3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;AACvB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB,EAAE,8BAA8B;IACzD,yBAAyB;IACzB,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,uBAAuB;AAC3B;;EAEE;IACE,yBAAyB,EAAE,8BAA8B;EAC3D;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,8BAA8B;EAChC;EACA;IACE,cAAc;IACd,iBAAiB;EACnB;EACA;;KAEG;EACH;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,eAAe;IACf,eAAe;IACf,gCAAgC;AACpC","sourcesContent":[".mcqMainDiv{\r\n  margin: 80px 24px 10px 24px;\r\n\r\n}\r\n.nextQuestionDiv{\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n.questionCard label{\r\n    display: flex;\r\n    margin-bottom: 15px;\r\n}\r\n.questionParagraph{\r\n    margin-bottom: 32px !important;\r\n}\r\n.questionChartItems {\r\n    border: 1px solid #000000;\r\n    padding: 7px;\r\n    background: #ffffff;\r\n    color: #070707;\r\n    border-radius: 100%;\r\n    width: 23px;\r\n    height: 20px;\r\n    /* cursor: pointer; */\r\n    display: flex;\r\n    justify-content: center;\r\n\r\n}\r\n.questionChartItems p {\r\n  display: contents;\r\n}\r\n.questionChartItemsSelected p {\r\n  display: contents;\r\n}\r\n.questionChartItemsDiv{\r\n    display: flex;\r\n    justify-content: space-around;\r\n    margin-bottom: 13px;\r\n}\r\n.mcqMainDiv .ant-card-bordered{\r\n    border: 1px solid #b5b5b5;\r\n}\r\n.mcqMainDiv .ant-card-head{\r\n    border-bottom: 1px solid #b5b5b5;\r\n}\r\n\r\n.questionChartItemsSelected {\r\n    background-color: #1677ff; /* Green for correct answers */\r\n    border: 1px solid #1677ff;\r\n    padding: 7px;\r\n    color: #ffffff;\r\n    border-radius: 100%;\r\n    width: 23px;\r\n    height: 20px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    justify-content: center;  \r\n}\r\n  \r\n  .questionChartItems.incorrect {\r\n    background-color: #ff6666; /* Red for incorrect answers */\r\n  }\r\n  .Thanks{\r\n    font-size: 60px;\r\n    font-weight: 400;\r\n    margin-top: 70px;\r\n    margin-bottom: 0px;\r\n  }\r\n  .mcq-res-MainDiv{\r\n    display:flex ;\r\n    justify-content: center;\r\n  }\r\n  .QuestionHeader{\r\n    display: flex;\r\n    justify-content: space-between;\r\n  }\r\n  .Ques-txt{\r\n    color: #0174fa;\r\n    padding-top: 16px;\r\n  }\r\n  /* .questionChartItems:hover{\r\n    background: #b6d8fff4;\r\n  } */\r\n  .mcq-res-MainDiv{\r\n    display: flex;\r\n  }\r\n  .BackToDashboard{\r\n    margin-left: 96px;\r\n  }\r\n  .completed{\r\n    text-align: center;\r\n  }\r\n  .back{\r\n    color: #4096FF;\r\n    cursor: pointer; \r\n    font-size: 12px;\r\n    /* text-decoration: underline; */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
